import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchProjects = createAsyncThunk(
    "projects/fetchProjects",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/project", { params });
            const result = response.data;
            // Handle the structure provided by user: result.data.items
            return {
                items: result?.data?.items || result?.data?.projects || result?.projects || (Array.isArray(result) ? result : []),
                pagination: result?.data?.pagination || null
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const deleteProjects = createAsyncThunk(
    "projects/deleteProjects",
    async (ids, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete("api/project", {
                data: { ids }
            });
            return { ids, message: response.data?.message || "Projects deleted successfully" };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
